import React from 'react';
import { Doughnut, Pie } from 'react-chartjs-2';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import {
    Card,
    CardHeader,
    CardContent,
    IconButton,
    Divider,
    Typography,
    Avatar,
    Paper,
    Chip
} from '@material-ui/core';
import LaptopMacIcon from '@material-ui/icons/LaptopMac';
import PhoneIphoneIcon from '@material-ui/icons/PhoneIphone';
import RefreshIcon from '@material-ui/icons/Refresh';
import TabletMacIcon from '@material-ui/icons/TabletMac';


import iconAgredSpotfi from '../../../../../images/agregadores/spotify.png';
import iconAgredGoogle from '../../../../../images/agregadores/google.png';
import iconAgredItunes from '../../../../../images/agregadores/itunes.png';
import iconAgredPlay from '../../../../../images/play.svg';

import CustomIcon from '../CustomIcon';
import { Link } from 'react-router-dom';
import palette from '../../../../../theme/palette';
import { LinkOutlined } from '@material-ui/icons';
import { defaultPaperPadding } from '../../../../../config';

const useStyles = makeStyles(theme => ({
    root: {
        height: '100%'
    },
    chartContainer: {
        position: 'relative',
        height: '300px'
    },
    stats: {
        marginTop: theme.spacing(2),
        display: 'flex',
        justifyContent: 'center'
    },
    device: {
        textAlign: 'center',
        padding: theme.spacing(1)
    },
    deviceIcon: {
        color: theme.palette.icon
    },
}));

const UsersByDevice = props => {
    const { oldGoogle, oldSpotify, oldItunes, className, ...rest } = props;


    const classes = useStyles();
    const theme = useTheme();

    const player = props.reproducoes.player;
    const spotify = props.reproducoes.spotify;
    const itunes = props.reproducoes.itunes;
    const google = props.reproducoes.google;

    const playTotal = spotify + itunes + google;
    const percent = parseInt((Math.abs((playTotal - (oldGoogle + oldSpotify + oldItunes))) / (oldGoogle + oldSpotify + oldItunes > 0 ? oldGoogle + oldSpotify + oldItunes : 1)) * 100)

    //let v = (vlor / valorTotal) * 100; 

    const percentPlay = player > 0 ? ((player / playTotal) * 100).toFixed(0) : 0;
    const percentSpotify = spotify > 0 ? ((spotify / playTotal) * 100).toFixed(0) : 0;
    const percentItunes = itunes > 0 ? ((itunes / playTotal) * 100).toFixed(0) : 0;
    const percentGoogle = google > 0 ? ((google / playTotal) * 100).toFixed(0) : 0;


    let valoresAgregadores = [spotify, itunes, google]

    const data = {
        datasets: [
            {
                pointRadius: 5,
                pointHoverRadius: 7,
                pointBackgroundColor: 'white',
                pointBorderWidth: 3,
                lineTension: 0,
                data: valoresAgregadores,
                backgroundColor: [
                    '#FFD059',
                    '#FFA400',
                    '#FF7509',
                ],
                borderWidth: 1,
                borderColor: [
                    '#FFD059',
                    '#FFA400',
                    '#FF7509',
                ],
                hoverBorderColor: theme.palette.white
            }
        ],
        labels: ['Spotify', 'iTunes', 'Google']
    };

    const options = {
        legend: {
            display: true,
            position: 'left',
            align: 'end',
            onHover: (evt) => {
                const leftSpacing = evt.clientX
                const topSpacing = evt.clientY

                const tooltipDiv = document.getElementById('customTooltip')
                tooltipDiv.style.left = (leftSpacing + 10) + 'px'
                tooltipDiv.style.top = (topSpacing - 3) + 'px'
                tooltipDiv.style.padding = '5px'

                tooltipDiv.innerText = 'Clique na leganda para tirar o canal do filtro'
            },
            onLeave: (evt) => {
                const tooltipDiv = document.getElementById('customTooltip')
                tooltipDiv.innerText = ''
                tooltipDiv.style.padding = '0px'
            }
        },
        responsive: true,
        maintainAspectRatio: false,
        animation: false,
        // cutoutPercentage: 80,
        layout: { padding: 0 },
        tooltips: {
            enabled: true,
            mode: 'index',
            intersect: false,
            borderWidth: 1,
            borderColor: theme.palette.divider,
            backgroundColor: theme.palette.white,
            titleFontColor: theme.palette.text.primary,
            bodyFontColor: theme.palette.text.secondary,
            footerFontColor: theme.palette.text.secondary,
        }
    };

    const devices = [
        {
            title: 'Spotify',
            value: percentSpotify,
            icon: <CustomIcon path={iconAgredSpotfi} />,
            color: theme.palette.agregadores.spotify
        },
        {
            title: 'iTunes',
            value: percentItunes,
            icon: <CustomIcon path={iconAgredItunes} />,
            color: theme.palette.agregadores.itunes,
        },
        {
            title: 'Google',
            value: percentGoogle,
            icon: <CustomIcon path={iconAgredGoogle} />,
            color: theme.palette.agregadores.google,
        }
    ];

    return (
        <Card
            // {...rest}
            // className={clsx(classes.root, className)}
            style={{ height: '100%', borderRadius: '15px', display: 'flex', flexDirection: 'column', padding: defaultPaperPadding }}
        >
            <div className={'paperData'}>
                <div style={{ padding: '10px 20px', color: 'grey' }} elevation={3}>
                    <h3>Redirecionamentos</h3>
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <h1 style={{ padding: '10px 0', marginRight: '5px' }}>{playTotal}</h1>
                        <h2 style={{ color: percent == 0 ? 'grey' : percent > 0 ? 'green' : 'red' }}>{percent == 0 ? '' : percent > 0 ? '+' : ''}{percent}%</h2>
                    </div>
                    <h3 style={{ color: 'lightgrey' }}>Número de vezes que seu conteúdo foi redirecionado</h3>
                </div>
            </div>
            <CardContent style={{ height: '100%', width: '100%' }}>
                <Doughnut
                    data={data}
                    options={options}
                />
            </CardContent>
        </Card>
    );
};

UsersByDevice.propTypes = {
    className: PropTypes.string
};




export default UsersByDevice;